<template>
    <div class="relative flex flex-col gap-2">
        <div
            class="absolute left-2 right-2 top-0 h-[80%] -z-30 shadow rounded-2xl border border-slate-100 bg-slate-200"
        ></div>

        <div class="p-6 flex items-start justify-between">
            <slot name="title"></slot>
            <vx-button
                @click="emit('clear')"
                data-test="clear-button"
                aria-label="Clear selection"
                size="sm"
                color="muted-dark"
            >
                <font-awesome-icon widthAuto :icon="faXmark" />
            </vx-button>
        </div>

        <div class="relative grow">
            <slot />
            <div
                v-if="count >= 2"
                class="absolute left-4 right-4 -top-2.25 -z-10 rounded-2xl border border-white/60 bg-slate-50/40 shadow h-16"
            />
            <div
                v-if="count >= 3"
                class="absolute left-9 right-9 -top-4.25 -z-20 rounded-2xl border border-white/20 bg-slate-50/10 shadow h-16"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface Props {
    count: number;
}

defineProps<Props>();

const emit = defineEmits<{
    clear: [];
}>();
</script>
